var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('loading',{attrs:{"active":_vm.active,"can-cancel":false,"is-full-page":_vm.fullPage || false},on:{"update:active":function($event){_vm.active=$event}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }